/* =========================================================
   GSRG — Move SALE + SOLD OUT badges to TOP LEFT
   ========================================================= */

(() => {
  const imp = (el, prop, val) => el.style.setProperty(prop, val, 'important');

  function moveBadges(root = document) {
    root.querySelectorAll('.card__badge').forEach(badge => {
      const text = (badge.textContent || '').toLowerCase();

      // Only affect SALE or SOLD OUT
      if (!text.includes('sale') && !text.includes('sold out')) return;

      const card = badge.closest('.card-wrapper');
      if (!card) return;

      imp(card, 'position', 'relative');
      imp(badge, 'position', 'absolute');
      imp(badge, 'top', '10px');
      imp(badge, 'left', '10px');
      imp(badge, 'right', 'auto');
      imp(badge, 'bottom', 'auto');
      imp(badge, 'z-index', '85');
    });
  }

  const run = () => moveBadges(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', run);
})();
